// extracted by mini-css-extract-plugin
export default {"minorLinkBox":"Footer_minorLinkBox__55qRq","minorLink":"Footer_minorLink__Z6EtW","black":"Footer_black__VMHcP"};